import { appStateService } from '@/state/app.state.service';
import { popupStateService } from '@/state/popup.state.service';

const dismissCheckoutOnPopState = (): void => {
  const showPayment = appStateService.showPaymentModal.get();
  const activeOrderId = appStateService.activeOrderId.get();
  const campaignOffer = appStateService.campaignOfferData.get();

  if (!showPayment && !activeOrderId && !campaignOffer) {
    return;
  }

  appStateService.setDisplayLoader(false);
  appStateService.setShowPaymentModal(false);
  appStateService.setActiveOrderId('');
  appStateService.setSelectedOffer(null);
  appStateService.setCampaignOfferData(undefined);
  popupStateService.setCurrentPopupDisplayed(null);
  document.getElementById('root')?.classList.remove('screen-lock');
};

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', dismissCheckoutOnPopState);
}
